__turbopack_context__.v({
  "colorBlue": "AIShowcaseSection-module-scss-module__B0wdQG__colorBlue",
  "colorGreen": "AIShowcaseSection-module-scss-module__B0wdQG__colorGreen",
  "colorOrange": "AIShowcaseSection-module-scss-module__B0wdQG__colorOrange",
  "colorPink": "AIShowcaseSection-module-scss-module__B0wdQG__colorPink",
  "container": "AIShowcaseSection-module-scss-module__B0wdQG__container",
  "section": "AIShowcaseSection-module-scss-module__B0wdQG__section",
  "solutionsList": "AIShowcaseSection-module-scss-module__B0wdQG__solutionsList",
  "stickyContainer": "AIShowcaseSection-module-scss-module__B0wdQG__stickyContainer",
});
